export default __webpack_public_path__ + "static/media/thankyoumobile.43a367b0.png";